import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";
import "./FeuC13BunkerQuantityCheck.scss";
import { c42Fields } from "../../FeuConstants";
import { useParams } from "react-router";
import { forwardRef, useEffect, useMemo, useRef } from "react";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuC13BunkerQualityCheck = forwardRef(({ c13Bunkering, refetchMonitoringData,vesselMstId }, ref) => {
	const { control, getValues, reset, formState } = useFormContext();
	const lastManualSave = useRef(null);
	const manualSaveTriggered = useRef(false);
	const savedValuesRef = useRef({});
	const { dirtyFields } = formState;
	const isC13Dirty = !!(dirtyFields?.c13 && Object.keys(dirtyFields.c13).length > 0);

	useEffect(() => {
		if (c13Bunkering) {
			reset(prev => ({ ...prev, c13: c13Bunkering }));
		}
	}, [c13Bunkering, reset]);
	const c23Fields = useMemo(() => {
		const SKIP = ["dataSources", "recordLocation", "itSystemName"];
		const NEW_LABEL =
			"Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)";

		return c42Fields
			.filter(({ name }) => !SKIP.includes(name))

			.map(field =>
				field.name === "descriptionOfProcedure"
					? { ...field, label: NEW_LABEL }
					: field
			);
	}, [c42Fields]);

	AutoSave(ref, [], async () => {
		const currentValues = getValues("c13");
		const isChanged = Object.keys(currentValues || {}).some(
			key => currentValues[key] !== savedValuesRef.current?.[key]
		);
		if (!isC13Dirty || !isChanged) return;
		await handleSave(true);
	});

	const handleSave = async (isAuto = false) => {
		const formValues = getValues("c13");
		const payload = {
			...c23Fields.reduce((acc, { name }) => {
				acc[name] = formValues?.[name] || "";
				return acc;
			}, {}),
		};
		try {
			const C23BunkeringQuantity = await callApi({
				method: "POST",
				url: API_ROUTES.C13(vesselMstId),
				data: payload,
			});
			if (C23BunkeringQuantity?.isSuccess) {
				emitToasterMsg("success", "Table C.1.3", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
				reset(prev => ({ ...prev, c1: formValues }));
				savedValuesRef.current = { ...formValues };
				if (!isAuto) {
					lastManualSave.current = Date.now();
				}
				if (typeof refetchMonitoringData === "function") {
					await refetchMonitoringData();
				}
			}
			else {
				emitToasterMsg("error", "Table C.1.3", C23BunkeringQuantity?.errorMessage);
			}
		} catch (error) {
			emitToasterMsg("error", "Table C.1.3", error.errorMessage);
		}
	};


	return (
		<div className="b7-section-form mt-4">
			<MDBRow className="mb-2">
				<MDBCol md="4">
					<h6 className="titles-font">Title of procedure</h6>
				</MDBCol>
				<MDBCol md="8">
					<h6 className="titles-font">Regular cross-checks between bunkering quantity as provided by BDNs and bunkering quantity indicated by on-board measurement</h6>
				</MDBCol>
			</MDBRow>
			{c23Fields.map(({ label, name, maxLength }, index) => (
				<MDBRow className="align-items-center mb-3" key={index}>
					<MDBCol md="4">
						<Label name={label} bold />
					</MDBCol>
					<MDBCol md="4">
						<Controller
							name={`c13.${name}`}
							control={control}
							render={({ field }) => (
								<TextArea
									id={`c13_${name}`}
									className="textarea-resize"
									value={field?.value || ""}
									onChange={field.onChange}
									placeholder=""
									maxLength={maxLength}
									rows={1}
								/>
							)}
						/>
					</MDBCol>
				</MDBRow>
			))}

			<div className="text-center">
				<Button id="c23_save_btn"
					disabled={!isC13Dirty}
					onClick={async () => {
						manualSaveTriggered.current = true;
						await handleSave(false);
					}}>Save</Button>
			</div>
		</div>
	);
});

export default FeuC13BunkerQualityCheck;
